// Lib Imports
import React from 'react';
import { Box, Heading, Image, Button } from 'grommet';

// Application Imports
import Activated from 'assets/Activated.svg';
const ActivationSuccess = ({
  history
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    margin: {
      top: 'medium',
      bottom: 'xlarge'
    }
  }, /*#__PURE__*/React.createElement(Image, {
    src: Activated
  })), /*#__PURE__*/React.createElement(Heading, {
    level: 3,
    margin: "none"
  }, "Activated Successfully!"), /*#__PURE__*/React.createElement(Heading, {
    level: 5,
    color: "dark-2"
  }, "Your account has been activated successfully"), /*#__PURE__*/React.createElement(Button, {
    primary: true,
    label: "Login Here",
    onClick: () => history.push('/login'),
    color: "secondary"
  }));
};
export default ActivationSuccess;